"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getBlockElementAtNode_1 = require("./getBlockElementAtNode");
/**
 * Get the first/last BlockElement of under the root node.
 * If no suitable BlockElement found, returns null
 * @param rootNode The root node to get BlockElement from
 * @param isFirst True to get first BlockElement, false to get last BlockElement
 */
function getFirstLastBlockElement(rootNode, isFirst) {
    var node = rootNode;
    do {
        node = node && (isFirst ? node.firstChild : node.lastChild);
    } while (node && node.firstChild);
    return node && getBlockElementAtNode_1.default(rootNode, node);
}
exports.default = getFirstLastBlockElement;
/**
 * Get the first BlockElement of under the root node.
 * If no suitable BlockElement found, returns null
 * @param rootNode The root node to get BlockElement from
 */
function getFirstBlockElement(rootNode) {
    return getFirstLastBlockElement(rootNode, true /*isFirst*/);
}
exports.getFirstBlockElement = getFirstBlockElement;
/**
 * Get the last BlockElement of under the root node.
 * If no suitable BlockElement found, returns null
 * @param rootNode The root node to get BlockElement from
 */
function getLastBlockElement(rootNode) {
    return getFirstLastBlockElement(rootNode, false /*isFirst*/);
}
exports.getLastBlockElement = getLastBlockElement;
//# sourceMappingURL=getFirstLastBlockElement.js.map